<template>
  <base-dialog
    v-model="localValue"
    :title="`Subscribe to ${plan.name} plan`"
    :show-footer="true"
    :persistent="true"
    :hide-close-button="false"
    :loading="loading"
    cancel-label="Cancel"
    confirm-label="Subscribe"
    confirm-button-class="base-dialog__primary-btn"
    @cancel="$emit('cancel')"
    @confirm="$emit('confirm')"
  >
    <div>
      <p class="confirmation-message q-mb-lg">Your plan will be activated immediately upon confirmation.</p>

      <!-- Combined section with grey background -->
      <div class="plan-section q-pa-md">
        <!-- Price section -->
        <div class="price-container q-mb-lg">
          <div class="plan-section-title q-mb-sm">Plan price</div>
          <div class="plan-price-display">
            <span class="plan-price-amount">{{ plan.price.amount | formatPrice }} {{ plan.price.currency }}</span>
            <span class="plan-price-period">/ {{ plan.interval === 'year' ? 'year' : 'month' }}</span>
          </div>
        </div>

        <div class="q-separator q-my-lg"></div>

        <!-- Features -->
        <div class="features-container">
          <div v-for="(feature, index) in plan.features" :key="index" class="feature-item q-mb-md">
            <q-icon name="check_circle" size="20px" color="primary" class="q-mr-sm" />
            <span class="feature-text">{{ feature }}</span>
          </div>
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'UpgradeConfirmDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    plan: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmation-message {
  @include inter-font($size: 16px, $bolded: false, $color: var(--main-text-color));
}

.plan-section {
  background-color: var(--main-bg-color);
  border-radius: 8px;
  border: 1px solid var(--terziary-btn-color);
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &-title {
    @include inter-font($size: 18px, $bolded: true, $color: var(--main-text-color));
  }
}

.plan-price {
  &-display {
    display: flex;
    align-items: baseline;
  }

  &-amount {
    @include inter-font($size: 32px, $bolded: true, $color: var(--main-text-color));
  }

  &-period {
    @include inter-font($size: 16px, $bolded: false, $color: var(--secondary-text-color));
    margin-left: 8px;
  }
}

.feature-item {
  display: flex;
  align-items: center;
}

.feature-text {
  @include inter-font($size: 14px, $bolded: false, $color: var(--main-text-color));
}

/* Make sure the separator is visible */
.q-separator {
  background-color: rgba(0, 0, 0, 0.1);
  height: 1px;
}
</style>
